
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import componentTitle from './componentTitle.vue';
    import defectList from './defectList.vue';

    interface TitleData {
        text: string;
        icon: string;
        clickFun: string;
    }

    interface State {
        titleText: string;
        titleData: TitleData;
        defectList: object[];
        listName: string;
        listDefectNumber: number;
        importantNumber: number;
        listSumNumber: number;
        reportLevel: number;
    }

    export default defineComponent({
        name: "StartUpCheck",
        setup() {
            let state: State = reactive({
                titleText: '启动检测',
                titleData: {
                    text: '标准说明',
                    icon: 'shuoming.png',
                    clickFun: 'showRemind',
                    modelCnt: [
                        '【启动故障认定标准】发动机启动状态、各故障灯及OBD模块检测、启动上电等，存在故障、启动困难、无法启动的故障及认定启动故障，车辆故障风险。',
                        'prop_up_height',
                        '【受限不可检】检测过程中，受环境、车主授权等不可抗原因导致无法检测，268V不对受限不可检的检测项产生的任何疑问负责。'
                    ]
                },
                defectList: [],
                listName: '启动检测',
                listDefectNumber: 0,
                importantNumber: 0,
                listSumNumber: 0,
                reportLevel: 0,
            })
            const {query} = useRoute();
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {startUp} = data;
                if (startUp) {
                    const {importantItemCount, defectItemCount, itemCount, itemList, itemTitle} = startUp;
                    state.defectList = itemList;
                    state.listName = itemTitle;
                    state.listDefectNumber = defectItemCount;
                    state.importantNumber = importantItemCount;
                    state.listSumNumber = itemCount;
                }
            })
            return {
                state
            }
        },
        components: {
            componentTitle, defectList
        }
    })
